export interface MijnAuthSessieManagerEnvironmentConfig {
    domain: string;
    clientId: string;
    audience: string;
}

const domain = '{<AUTH0_DOMAIN>}'.startsWith('{<') ? 'id-tst.np.asnbank.nl' : '{<AUTH0_DOMAIN>}';
const clientId = '{<AUTH0_CLIENTID>}'.startsWith('{<') ? 'xf6fZEU7cgFi7eISPHJhXYWqR6b3k4AM' : '{<AUTH0_CLIENTID>}';
const audience = '{<AUTH0_AUDIENCE>}'.startsWith('{<') ? 'urn:asnbank:internet' : '{<AUTH0_AUDIENCE>}';

export const MIJN_AUTH_SESSIE_MANAGER_ENVIRONMENT: MijnAuthSessieManagerEnvironmentConfig = {
    domain,
    clientId,
    audience
};

export const MIJN_AUTH_SESSIE_MANAGER_API_BASE_URL: string | null = '{<API_BASE_URL>}'.startsWith('{<') ? null : '{<API_BASE_URL>}';
